var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@mp/locale';
import Button from '../../button';
import "./property-styles.scss";
import SignUpForm from "../SignUpForm/SignUpForm";
import Map from "../Map/Map";
export default function PropertyNotFound(_a) {
    var searchableAddress = _a.searchableAddress, errorCode = _a.errorCode, country = _a.country, checkAnother = _a.checkAnother;
    if (errorCode === 'capturesvcs.address_not_found') {
        return (_jsxs("div", __assign({ className: "flexColumn" }, { children: [_jsx("h1", __assign({ "data-qa": "address-not-found", className: "capture-services-map-banner capture-services-address-error capture-services-address-error-only-msg" }, { children: t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.ERRORS.ADDRESS_NOT_SUPPORTED") })), _jsx("div", __assign({ className: "mp-capturesvc-button-container" }, { children: _jsx("button", __assign({ className: "button-new-inverted", onClick: checkAnother, type: "button" }, { children: t("CAPTURE_SERVICES.SIGNUP.ACTIONS.checkAnother") })) }))] })));
    }
    var mapType = 'error';
    return (_jsxs("div", __assign({ className: "flexColumn" }, { children: [_jsxs("p", __assign({ "data-qa": "address-not-found", className: "capture-services-map-banner capture-services-address-".concat(mapType) }, { children: [" ", t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.ERRORS.ADDRESS_NOT_COVERED_NEW"), " "] })), _jsx(Map, { address: searchableAddress, mapType: mapType }), _jsx("div", __assign({ className: "position-right" }, { children: _jsx(Button, { className: "button-new", dark: true, "data-qa": "address-confirmed-button", label: t("CAPTURE_SERVICES.SCHEDULER.next"), 
                    // onClick={nextButton}
                    disabled: true, buttonType: "primary", htmlId: "address-confirmed-button" }) })), _jsx(SignUpForm, { country: country, onBackButtonClicked: checkAnother })] })));
}
